"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsalService = void 0;
var tslib_1 = require("tslib");
var msal_browser_1 = require("@azure/msal-browser");
var MsalService = /** @class */ (function () {
    function MsalService(msalConfiguration, policyConfiguration, handleSignInRedirect) {
        this.interactions = [];
        this.state = {
            clientApp: new msal_browser_1.PublicClientApplication(msalConfiguration),
            policyConfig: policyConfiguration,
            handleSignInRedirect: handleSignInRedirect
        };
    }
    MsalService.prototype.queueInteraction = function () {
        this.interactions.push(Date.now());
    };
    MsalService.prototype.dequeueInteraction = function () {
        this.interactions.pop();
    };
    MsalService.prototype.hasPendingInteractions = function () {
        return this.interactions.length > 0;
    };
    MsalService.prototype.handleSignInRedirect = function () {
        var _a;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var result, tokenResult, e_1;
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.executeInteraction(function (app) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () { return (0, tslib_1.__generator)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, app.handleRedirectPromise()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); })];
                    case 1:
                        result = _b.sent();
                        if (!(result === null || result === void 0 ? void 0 : result.account)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.executeInteraction(function (app) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                                var _a;
                                return (0, tslib_1.__generator)(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, app.acquireTokenSilent({
                                                account: result.account || undefined,
                                                scopes: ((_a = this.state.policyConfig) === null || _a === void 0 ? void 0 : _a.signUpSignIn.scopes) || []
                                            })];
                                        case 1: return [2 /*return*/, _b.sent()];
                                    }
                                });
                            }); })];
                    case 2:
                        tokenResult = _b.sent();
                        this.state.account = result.account;
                        this.state.token = tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.accessToken;
                        if (this.state.handleSignInRedirect && (tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.accessToken)) {
                            this.state.handleSignInRedirect(result.account, tokenResult.accessToken);
                        }
                        return [3 /*break*/, 6];
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.refreshToken((_a = this.state.policyConfig) === null || _a === void 0 ? void 0 : _a.signUpSignIn)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        // ignore silent login errors - this will happen if the cached account has expired
                        console.warn(e_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign in the user using Azure AD B2C via MSAL
     */
    MsalService.prototype.signIn = function (policy) {
        var _a;
        if (policy === void 0) { policy = (_a = this.state.policyConfig) === null || _a === void 0 ? void 0 : _a.signUpSignIn; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.executeInteraction(function (app) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                            return (0, tslib_1.__generator)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, app.loginRedirect({
                                            scopes: (policy === null || policy === void 0 ? void 0 : policy.scopes) || [],
                                            authority: policy === null || policy === void 0 ? void 0 : policy.authority
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign out the user using Azure AD B2C via MSAL
     */
    MsalService.prototype.signOut = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.executeInteraction(function (app) {
                            return app.logoutRedirect();
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign in the user using Azure AD B2C via MSAL and edit their profile
     */
    MsalService.prototype.editProfile = function (policy) {
        var _a;
        if (policy === void 0) { policy = (_a = this.state.policyConfig) === null || _a === void 0 ? void 0 : _a.editProfile; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // edit profile works the same ways as sign-in, except it has a different policy id in the authority url
                    return [4 /*yield*/, this.signIn(policy)];
                    case 1:
                        // edit profile works the same ways as sign-in, except it has a different policy id in the authority url
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign in the user using Azure AD B2C via MSAL and allow them to change their password.
     */
    MsalService.prototype.resetPassword = function (policy) {
        var _a;
        if (policy === void 0) { policy = (_a = this.state.policyConfig) === null || _a === void 0 ? void 0 : _a.resetPassword; }
        // reset password works the same ways as sign-in, except it has a different policy id in the authority url
        return this.signIn(policy);
    };
    /**
     * Gets the logged in account from MSAL
     * @returns the account info if logged in
     */
    MsalService.prototype.getAccount = function () {
        var app = this.validateClient();
        var accounts = app.getAllAccounts();
        if (accounts && accounts.length > 0) {
            var account = accounts[0];
            this.state.account = account;
            return account;
        }
        return null;
    };
    /**
     * Attempt to silently acquire a new token via AAD B2C MSAL.
     */
    MsalService.prototype.refreshToken = function (policy) {
        var _a;
        if (policy === void 0) { policy = (_a = this.state.policyConfig) === null || _a === void 0 ? void 0 : _a.signUpSignIn; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var account, result;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        account = this.state.account || this.getAccount();
                        if (!account) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.executeInteraction(function (app) {
                                // Get a token for the already logged in account
                                return app.acquireTokenSilent({
                                    account: account,
                                    scopes: (policy === null || policy === void 0 ? void 0 : policy.scopes) || []
                                });
                            })];
                    case 1:
                        result = _b.sent();
                        if (result && result.accessToken) {
                            this.state.token = result.accessToken;
                            if (this.state.handleSignInRedirect) {
                                this.state.handleSignInRedirect(result.account, result.accessToken);
                            }
                            return [2 /*return*/, result.accessToken];
                        }
                        return [2 /*return*/, this.state.token || null];
                }
            });
        });
    };
    MsalService.prototype.validateClient = function () {
        if (!this.state.clientApp) {
            throw new Error("No MSAL client application provided");
        }
        return this.state.clientApp;
    };
    MsalService.prototype.executeInteraction = function (interaction) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var app, err_1;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        app = this.validateClient();
                        if (!!this.hasPendingInteractions()) return [3 /*break*/, 6];
                        this.queueInteraction();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, interaction(app)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_1 = _a.sent();
                        this.dequeueInteraction();
                        throw err_1;
                    case 4:
                        this.dequeueInteraction();
                        return [7 /*endfinally*/];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        console.warn("@elite/msal|MsalService: Ignoring interaction while there are pending interactions. See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/errors.md#interaction_in_progress");
                        _a.label = 7;
                    case 7: return [2 /*return*/, Promise.resolve(undefined)];
                }
            });
        });
    };
    return MsalService;
}());
exports.MsalService = MsalService;
//# sourceMappingURL=MsalService.js.map